<template>
    <el-button :type="status ? 'success' : 'warning'" :size="size"  @click="doUse">
            <i class="fa" :class="[status ? 'fa-unlock' : 'fa-lock']"></i>&nbsp;{{status? '点击启用' : '点击停用'}}
    </el-button>
</template>
<script>
    /**
     * 停用／启用 按钮
     * @author zjs
     * @time 2017-12-13
     * @param infoId 【description: ID,如12】
     * @param isdisabled 【description: 是否禁用,true,false】
     * @param route 【description: 路由】
     * @param style 【description: 类型 , 如 三包登记，三包理赔】
     */
    export default {
        name: 'LyButtonUse',
        props: {
            infoId: {
                type: [String, Number],
                default: ''
            }, 
            size: {
                type: String,
                default: 'small'
            },
            status: [Boolean, Number],
            // 作废完成后的回调函数
            callback: Function 
        },
        methods: {
            /**
             * 停用 启用处理
             */
            doUse () {
                this.$api.create('api/staff/' + this.infoId + '/on', {
                    is_delete: !this.status
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '提交成功'
                    })
                    // 调用回调函数
                    if (this.callback) {
                        this.callback(!this.status)
                    }
                }).catch((msg) => {
                    this.$message({
                        type: 'warning',
                        message: msg
                    })
                })
            }
        }
    }
</script>